import { type RowData } from '@tanstack/react-table';

import { DimeCheckbox } from '../DimeCheckbox.js';
import type { ColumnDef, SelectAllControl } from './DimeDataTable.types.js';

export function buildSelectionColumn<TData extends RowData>(
  showSelectAll = true,
  selectAll?: SelectAllControl,
): ColumnDef<TData, unknown> {
  return {
    id: 'select',
    meta: { headerClassName: 'w-10' },
    enableSorting: false,
    enableHiding: false,
    header: ({ table }) =>
      selectAll ? (
        <DimeCheckbox
          checked={selectAll.checked}
          onCheckedChange={(value) => selectAll.onCheckedChange(value === true)}
          aria-label={selectAll.label ?? 'Select all'}
        />
      ) : showSelectAll ? (
        <DimeCheckbox
          checked={
            table.getIsAllPageRowsSelected() ||
            (table.getIsSomePageRowsSelected() ? 'indeterminate' : false)
          }
          onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
          aria-label="Select all"
        />
      ) : (
        <span className="sr-only">Select</span>
      ),
    cell: ({ row }) => (
      <DimeCheckbox
        checked={row.getIsSelected()}
        disabled={!row.getCanSelect()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
        onClick={(event) => event.stopPropagation()}
      />
    ),
  };
}
